// Module
var code = " <mat-icon class=\"no-entry-icon\" [ngStyle]=\"{ width: this.size, height: this.size }\" svgIcon=\"gh:zoom-empty\"></mat-icon> <div class=\"placeholder-panel__title\">{{ label }}</div> ";
// Exports
module.exports = code;